import { DataResponse, Merchant } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { v4 as uuidv4 } from "uuid";

export const walletInternalTransferService = createApi({
  reducerPath: "walletInternalTransferService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    updateRecipientAccount: builder.mutation<DataResponse<any>, { id: number }>({
      query: (body: any) => ({
        url: `/wallet-transfer/receiver/${body.id}`,
        body,
        method: "PUT",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    createRecipientAccount: builder.mutation<any, any>({
      query: (body: any) => ({
        url: "/wallet-transfer/receiver",
        body,
        method: "POST",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    getListRecipientAccount: builder.query<any, { page: number; limit: number }>({
      query: (params) => ({
        url: `/wallet-transfer/receiver`,
        method: "GET",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
        params: { page: params?.page, limit: params?.limit },
      }),
    }),
    getListPaymentService: builder.query<any, void>({
      query: () => ({
        url: `/wallet-transfer/payer`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    getListTransferFund: builder.query<any, { page: number; limit: number }>({
      query: (params) => ({
        url: `/wallet-transfer/transfer`,
        method: "GET",
        params,
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    getDetailTransferFund: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/wallet-transfer/transfer/${params?.id}`,
        method: "GET",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    getBalance: builder.query<any, any>({
      query: (params) => ({
        url: `/wallet-transfer/balance`,
        params,
        method: "GET",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    deleteRecipientAccount: builder.mutation<any, any>({
      query: (params) => ({
        url: `/wallet-transfer/receiver/${params.id}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    updateTransfer: builder.mutation<DataResponse<any>, { id: number }>({
      query: (body: any) => ({
        url: `/wallet-transfer/transfer/${body.id}`,
        body,
        method: "PUT",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    createTransfer: builder.mutation<any, any>({
      query: (body: any) => ({
        url: "/wallet-transfer/transfer",
        body,
        method: "POST",
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    getTransferLogs: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/wallet-transfer/transfer/${params?.id}/logs`,
        method: "GET",
        params,
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
    getRecipientAccountLogs: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/wallet-transfer/receiver/${params?.id}/logs`,
        method: "GET",
        params,
        headers: {
          PageName: "Wallet Internal Transfer",
        },
      }),
    }),
  }),
});

export const {
  useCreateRecipientAccountMutation,
  useUpdateRecipientAccountMutation,
  useGetListPaymentServiceQuery,
  useGetListRecipientAccountQuery,
  useGetListTransferFundQuery,
  useLazyGetListTransferFundQuery,
  useLazyGetDetailTransferFundQuery,
  useLazyGetBalanceQuery,
  useDeleteRecipientAccountMutation,
  useCreateTransferMutation,
  useUpdateTransferMutation,
  useLazyGetTransferLogsQuery,
  useLazyGetRecipientAccountLogsQuery,
} = walletInternalTransferService;
